/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimit_Protipbody3Inputs */

const he_ratelimit_protipbody3 = /** @type {(inputs: Ratelimit_Protipbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משתמשים מחוברים מקבלים פי 3 יותר גישה. התחבר כדי לפתוח את המסלול המהיר!`)
};

const en_ratelimit_protipbody3 = /** @type {(inputs: Ratelimit_Protipbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logged-in users get 3× more browsing power. Sign in to unlock the fast lane!`)
};

/**
* | output |
* | --- |
* | "Logged-in users get 3× more browsing power. Sign in to unlock the fast lane!" |
*
* @param {Ratelimit_Protipbody3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const ratelimit_protipbody3 = /** @type {((inputs?: Ratelimit_Protipbody3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimit_Protipbody3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_ratelimit_protipbody3(inputs)
	return en_ratelimit_protipbody3(inputs)
});
export { ratelimit_protipbody3 as "rateLimit_proTipBody" }